import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { equals2v6cggk171b6e as equals } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/stringsCode.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { flatten2dh4kibw1u0qq as flatten } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { copyToArray2j022khrow2yi as copyToArray } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { awaitd1m8y0em728c as await_0 } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Promise.mjs';
import { joinToString1cxrrlmo0chqs as joinToString } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { PlatformUtils_getInstance8t6iqcjia1rj as PlatformUtils_getInstance } from '../../../../../../ktor-ktor-utils/io/ktor/util/PlatformUtils.mjs';
import { GMTDate36bhedawynxlf as GMTDate } from '../../../../../../ktor-ktor-utils/io/ktor/util/date/DateJs.mjs';
import {
  get_WEBSOCKETS_KEY4y3dps3lzl71 as get_WEBSOCKETS_KEY,
  WebSocketCapability_instance3njpsmtb92gfn as WebSocketCapability_instance,
  WebSocketExceptionb5mwyitzck0i as WebSocketException,
} from '../../plugins/websocket/WebSockets.mjs';
import { JsWebSocketSession2h93x4rgbt7zw as JsWebSocketSession } from '../../plugins/websocket/JsWebSocketSession.mjs';
import { CancellationExceptionjngvjj221x3v as CancellationException } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Exceptions.mjs';
import {
  cancel2en0dn4yvpufo as cancel,
  get_job2zvlvce9o9a29 as get_job,
} from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Job.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  Companion_getInstance1fjhglsqufscv as Companion_getInstance,
  headersOf2tgdoojg8tifn as headersOf,
} from '../../../../../../ktor-ktor-http/io/ktor/http/Headers.mjs';
import {
  Companion_getInstancek3kgntyryryj as Companion_getInstance_0,
  HttpStatusCode3o1wkms10pg4k as HttpStatusCode,
} from '../../../../../../ktor-ktor-http/io/ktor/http/HttpStatusCode.mjs';
import { Companion_getInstance2tcwwhth1llr7 as Companion_getInstance_1 } from '../../../../../../ktor-ktor-http/io/ktor/http/HttpProtocolVersion.mjs';
import {
  HttpResponseData2dozo5khuplr6 as HttpResponseData,
  isUpgradeRequest3msdo2i9hxs68 as isUpgradeRequest,
  get_ResponseAdapterAttributeKey1ll13ywinsgvd as get_ResponseAdapterAttributeKey,
} from '../../request/HttpRequest.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { HttpClientEngineBase2tgisnw4e4drr as HttpClientEngineBase } from '../HttpClientEngineBase.mjs';
import { HttpTimeoutCapability_instancec8hwguxy67pm as HttpTimeoutCapability_instance } from '../../plugins/HttpTimeout.mjs';
import { SSECapability_instance2tnjplkjmvlh3 as SSECapability_instance } from '../../plugins/sse/SSE.mjs';
import { setOf45ia9pnfhe90 as setOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { callContext2e84l3ouegzno as callContext } from '../Utils.mjs';
import { get_CLIENT_CONFIG1oazdiwjd1qe0 as get_CLIENT_CONFIG } from '../HttpClientEngine.mjs';
import { toRaw3l0hsmz0py53 as toRaw } from './JsUtils.mjs';
import { Companion_getInstance3elk0wbobqzqc as Companion_getInstance_2 } from '../../JsRequestUtils.mjs';
import {
  commonFetch18v4m3huf4jde as commonFetch,
  readBody4gczno2wau05 as readBody,
} from './compatibility/Utils.mjs';
import { CoroutineScopelux7s7zphw7e as CoroutineScope } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { dropCompressionHeaders12falb2m2fkr1 as dropCompressionHeaders } from '../../utils/HeadersUtils.mjs';
import { buildHeaders3beu05fiq9iq2 as buildHeaders } from '../../utils/headers.mjs';
import { intercepted2ogpsikxxj4u0 as intercepted } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { CancellableContinuationImpl1cx201opicavg as CancellableContinuationImpl } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CancellableContinuationImpl.mjs';
import { throwUninitializedPropertyAccessException14fok093f3k3t as throwUninitializedPropertyAccessException } from '../../../../../../kotlin-kotlin-stdlib/kotlin/internal/ThrowHelpers.mjs';
import {
  Companion_instance1xjg859pd52fi as Companion_instance,
  createFailure8paxfkfa5dc7 as createFailure,
  _Result___init__impl__xyqfz823vatsdepqb9n as _Result___init__impl__xyqfz8,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/Result.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *createWebSocket($this, urlString_capturingHack, headers, $completion) {
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = headers.l4p();
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList().p2();
  var _iterator__ex2g4s = tmp0.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    if (equals(element, 'Sec-WebSocket-Protocol', true)) {
      destination.i2(element);
    }
  }
  var protocolHeaderNames = destination;
  // Inline function 'kotlin.collections.mapNotNull' call
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination_0 = ArrayList().p2();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s_0 = protocolHeaderNames.p1();
  while (_iterator__ex2g4s_0.q1()) {
    var element_0 = _iterator__ex2g4s_0.r1();
    var tmp0_safe_receiver = headers.k4p(element_0);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination_0.i2(tmp0_safe_receiver);
    }
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  var this_0 = flatten(destination_0);
  var protocols = copyToArray(this_0);
  var tmp;
  if (PlatformUtils_getInstance().w4o_1) {
    tmp = new WebSocket(urlString_capturingHack, protocols);
  } else {
    var ws_import = import('ws');
    var ws_capturingHack = (yield* await_0(ws_import, $completion)).default;
    var headers_capturingHack = new (JsClientEngine$createWebSocket$headers_capturingHack$1())();
    headers.q4p((name, values) => {
      headers_capturingHack[name] = joinToString(values, ',');
      return Unit_instance;
    });
    tmp = new ws_capturingHack(urlString_capturingHack, protocols, {headers: headers_capturingHack});
  }
  return tmp;
}
function *executeWebSocketRequest($this, request, callContext, $completion) {
  var requestTime = GMTDate();
  var urlString = request.i5m_1.toString();
  var wsConfig = request.n5m_1.a4n(get_WEBSOCKETS_KEY());
  var socket = yield* /*#__NOINLINE__*/createWebSocket($this, urlString, request.k5m_1, $completion);
  var session = new (JsWebSocketSession())(callContext, socket, wsConfig.r5x_1);
  try {
    yield* awaitConnection(socket, $completion);
  } catch ($p) {
    if ($p instanceof Error) {
      var cause = $p;
      cancel(callContext, CancellationException('Failed to connect to ' + urlString, cause));
      throw cause;
    } else {
      throw $p;
    }
  }
  // Inline function 'kotlin.takeIf' call
  var this_0 = socket.protocol;
  var tmp;
  // Inline function 'kotlin.text.isNotEmpty' call
  if (charSequenceLength(this_0) > 0) {
    tmp = this_0;
  } else {
    tmp = null;
  }
  var protocol = tmp;
  var headers = !(protocol == null) ? headersOf('Sec-WebSocket-Protocol', protocol) : Companion_getInstance().r50_1;
  return new (HttpResponseData())(Companion_getInstance_0().j52_1, requestTime, headers, Companion_getInstance_1().b52_1, session, callContext);
}
function JsClientEngine$execute$lambda(_this__u8e3s4) {
  return Unit_instance;
}
var JsClientEngine$createWebSocket$headers_capturingHack$1Class;
function JsClientEngine$createWebSocket$headers_capturingHack$1() {
  if (JsClientEngine$createWebSocket$headers_capturingHack$1Class === VOID) {
    class $ {}
    initMetadataForClass($);
    JsClientEngine$createWebSocket$headers_capturingHack$1Class = $;
  }
  return JsClientEngine$createWebSocket$headers_capturingHack$1Class;
}
var JsClientEngineClass;
function JsClientEngine() {
  if (JsClientEngineClass === VOID) {
    class $ extends HttpClientEngineBase() {
      constructor(config) {
        super('ktor-js');
        this.f61_1 = config;
        this.g61_1 = setOf([HttpTimeoutCapability_instance, WebSocketCapability_instance, SSECapability_instance]);
        // Inline function 'kotlin.check' call
        if (!(this.f61_1.m5n_1 == null)) {
          var message = 'Proxy unsupported in Js engine.';
          throw IllegalStateException().o(toString(message));
        }
      }
      y5h() {
        return this.f61_1;
      }
      p5m() {
        return this.g61_1;
      }
      *d5n(data, $completion) {
        var callContext_0 = yield* callContext($completion);
        var clientConfig = data.n5m_1.a4n(get_CLIENT_CONFIG());
        if (isUpgradeRequest(data)) {
          return yield* /*#__NOINLINE__*/executeWebSocketRequest(this, data, callContext_0, $completion);
        }
        var requestTime = GMTDate();
        var rawRequest = yield* toRaw(data, clientConfig, callContext_0, $completion);
        var tmp0_safe_receiver = data.n5m_1.b4n(Companion_getInstance_2().q60_1);
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.r60_1;
        var tmp;
        if (tmp1_elvis_lhs == null) {
          tmp = JsClientEngine$execute$lambda;
        } else {
          tmp = tmp1_elvis_lhs;
        }
        var fetchOptions = tmp;
        var rawResponse = yield* commonFetch(data.i5m_1.toString(), rawRequest, fetchOptions, this.f61_1, get_job(callContext_0), $completion);
        var status = new (HttpStatusCode())(rawResponse.status, rawResponse.statusText);
        var headers = mapToKtor(rawResponse.headers, data.j5m_1, data.n5m_1);
        var version = Companion_getInstance_1().b52_1;
        var body = readBody(CoroutineScope(callContext_0), rawResponse);
        var tmp2_safe_receiver = data.n5m_1.b4n(get_ResponseAdapterAttributeKey());
        var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.s5y(data, status, headers, body, data.l5m_1, callContext_0);
        var responseBody = tmp3_elvis_lhs == null ? body : tmp3_elvis_lhs;
        return new (HttpResponseData())(status, requestTime, headers, version, responseBody, callContext_0);
      }
    }
    initMetadataForClass($, 'JsClientEngine', VOID, VOID, VOID, [1, 2]);
    JsClientEngineClass = $;
  }
  return JsClientEngineClass;
}
function mapToKtor(_this__u8e3s4, method, attributes) {
  return buildHeaders(($this$buildHeaders) => {
    // Inline function 'kotlin.js.asDynamic' call
    _this__u8e3s4.forEach((value, key) => {
      $this$buildHeaders.o4p(key, value);
      return Unit_instance;
    });
    dropCompressionHeaders($this$buildHeaders, method, attributes, PlatformUtils_getInstance().w4o_1);
    return Unit_instance;
  });
}
function *awaitConnection(_this__u8e3s4, $completion) {
  // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine' call
  // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
  return yield () => {
    var uCont = $completion;
    var cancellable = new (CancellableContinuationImpl())(intercepted(uCont), 1);
    cancellable.q10();
    $l$block: {
      var continuation = cancellable;
      if (continuation.pw()) {
        break $l$block;
      }
      var eventListener = {_v: null};
      eventListener._v = (event) => {
        var tmp;
        if (eventListener._v == null) {
          throwUninitializedPropertyAccessException('eventListener');
        } else {
          tmp = eventListener._v;
        }
        _this__u8e3s4.removeEventListener('open', tmp);
        var tmp_0;
        if (eventListener._v == null) {
          throwUninitializedPropertyAccessException('eventListener');
        } else {
          tmp_0 = eventListener._v;
        }
        _this__u8e3s4.removeEventListener('error', tmp_0);
        var tmp0_subject = event.type;
        var tmp_1;
        if (tmp0_subject === 'open') {
          var tmp0 = continuation;
          // Inline function 'kotlin.coroutines.resume' call
          // Inline function 'kotlin.Companion.success' call
          var value = _this__u8e3s4;
          var tmp$ret$5 = _Result___init__impl__xyqfz8(value);
          tmp0.oc(tmp$ret$5);
          tmp_1 = Unit_instance;
        } else if (tmp0_subject === 'error') {
          var tmp0_0 = continuation;
          // Inline function 'kotlin.coroutines.resumeWithException' call
          // Inline function 'kotlin.Companion.failure' call
          var exception = WebSocketException().m5x(asString(event));
          var tmp$ret$7 = _Result___init__impl__xyqfz8(createFailure(exception));
          tmp0_0.oc(tmp$ret$7);
          tmp_1 = Unit_instance;
        }
        return Unit_instance;
      };
      var tmp;
      if (eventListener._v == null) {
        throwUninitializedPropertyAccessException('eventListener');
      } else {
        tmp = eventListener._v;
      }
      _this__u8e3s4.addEventListener('open', tmp);
      var tmp_0;
      if (eventListener._v == null) {
        throwUninitializedPropertyAccessException('eventListener');
      } else {
        tmp_0 = eventListener._v;
      }
      _this__u8e3s4.addEventListener('error', tmp_0);
      continuation.yy((it) => {
        var tmp;
        if (eventListener._v == null) {
          throwUninitializedPropertyAccessException('eventListener');
        } else {
          tmp = eventListener._v;
        }
        _this__u8e3s4.removeEventListener('open', tmp);
        var tmp_0;
        if (eventListener._v == null) {
          throwUninitializedPropertyAccessException('eventListener');
        } else {
          tmp_0 = eventListener._v;
        }
        _this__u8e3s4.removeEventListener('error', tmp_0);
        var tmp_1;
        if (!(it == null)) {
          _this__u8e3s4.close();
          tmp_1 = Unit_instance;
        }
        return Unit_instance;
      });
    }
    return cancellable.ay();
  };
}
function asString(_this__u8e3s4) {
  // Inline function 'kotlin.text.buildString' call
  // Inline function 'kotlin.apply' call
  var this_0 = StringBuilder().l1();
  var tmp = JSON;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$3 = ['message', 'target', 'type', 'isTrusted'];
  this_0.m1(tmp.stringify(_this__u8e3s4, tmp$ret$3));
  return this_0.toString();
}
//region block: exports
export {
  JsClientEngine as JsClientEngine2d6599fsx5fyf,
};
//endregion

//# sourceMappingURL=JsClientEngine.mjs.map
